import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { internalSharedReportRevoke } from '../../../apiServices/reducer/dialogApiService';
import { showPmrSuccess, showPmrError, showPmrConfirm } from '../../../utils/swalUtils';

const GiveUpAccessModal = ({ show, onHide, rowData, isRevokeAction = false, activeTab, onSuccess }) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    const [isProcessing, setIsProcessing] = useState(false);
    const token = useSelector((state) => state.apiService?.token);

    useEffect(() => {
        if (show && !isProcessing && rowData) {
            showRevokeConfirmation();
        }
    }, [show, rowData, isRevokeAction]);

    const showRevokeConfirmation = () => {
        if (!rowData?.sharedBy) {
            handleClose();
            return;
        }

        setIsProcessing(true);
        const actionTitle = isRevokeAction ? 'Revoke Access' : 'Give up access';

        let actionText;
        if (isRevokeAction) {
            actionText = `Are you sure you want to revoke access for report shared to <span style="color: var(--pmr-swal-title-color); font-weight: bold; text-transform: uppercase;">${rowData.sharedBy}</span>?`;
        } else if (activeTab === "Approve Access") {
            actionText = `You want to give up access for report requested from <span style="color: var(--pmr-swal-title-color); font-weight: bold; text-transform: uppercase;">${rowData.shared_to_user}</span>?`;
        } else {
            actionText = `You want to give up access for report shared by <span style="color: var(--pmr-swal-title-color); font-weight: bold; text-transform: uppercase;">${rowData.sharedBy}</span>?`;
        }

        showPmrConfirm({
            title: actionTitle,
            html: `<div class="pmr-popup-message">${actionText}</div>`,
            confirmText: 'Yes',
            cancelText: 'No',
            confirmButtonColor: 'var(--pmr-danger)',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                revokeAccess();
            } else {
                handleClose();
            }
        }).finally(() => {
            setIsProcessing(false);
        });
    };

    const handleClose = () => {
        setIsProcessing(false);
        onHide(false);
    };

    const revokeAccess = async () => {
        try {
            if (!token || !rowData?.share_id || !userData?.user_id) {
                handleClose();
                return;
            }

            const formData = {
                ShareID: parseInt(rowData.share_id),
                LoginUserID: parseInt(userData.user_id),
                token: token
            };
            const result = await dispatch(internalSharedReportRevoke(formData)).unwrap();
            if (result === true) {
                const successMessage = isRevokeAction
                    ? `Access revoked successfully for report shared to <span style="color: var(--pmr-swal-title-color); font-weight: bold; text-transform: uppercase;">${rowData.sharedBy}</span>`
                    : activeTab === "Approve Access"
                        ? `Access given up successfully for report shared from <span style="color: var(--pmr-swal-title-color); font-weight: bold; text-transform: uppercase;">${rowData.sharedBy}</span>`
                        : `Access given up successfully for report shared by <span style="color: var(--pmr-swal-title-color); font-weight: bold; text-transform: uppercase;">${rowData.sharedBy}</span>`;
                await showPmrSuccess({ html: `<div class="pmr-popup-message">${successMessage}</div>`, timer: 2000 });
                if (onSuccess) {
                    onSuccess();
                }
                handleClose();
            } else {
                await showPmrError(isRevokeAction
                    ? 'Failed to revoke access. Please try again.'
                    : 'Failed to give up access. Please try again.');
                handleClose();
            }
        } catch (error) {
            let errorMessage = 'An error occurred while revoking access';
            if (error.response?.status === 401) {
                errorMessage = 'Your session has expired. Please login again.';
            } else if (error.message === 'Token is required') {
                errorMessage = 'Authentication token is missing. Please login again.';
            }
            await showPmrError(errorMessage);
            handleClose();
        }
    };

    return null;
};

export default GiveUpAccessModal;
